module.exports = __webpack_public_path__ + "static/media/logo_sm.7f4f091d.svg";